export default {
  language: 'English',
  menu: {
    slab: 'Slab',
    spot: 'Spot',
    share: 'Shared',
    local: 'Local',
    benefits: 'VIP Benefits',
    user: 'User',
    home: 'Home' // Corrected typ
  },
  search: 'Search',
  searchPlaceholder: 'Search Keyword',
  searchPlaceholderThickness: 'Enter thickness, such as 30 or 30mm',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  noData: 'No Data',
  thickness: 'Thickness',
  processing_surface: 'Surface',
  // Add new fields
  loading: 'Loading',
  allLoaded: 'All results',
  loadMore: 'Loading More',
  notFound: 'Not Found',
  stoneType: 'Stone Type',
  stoneNo: 'Batch No.',
  shelfCount: 'Shelves',
  totalPiece: 'Total Pieces',
  basicInfo: 'Inventory information',
  sumArea: 'Total Area',
  filterTitle: 'Filters',
  bookMatch: 'Book Match',
  material: 'Material',
  lot: 'Block No.',
  total_quantity: 'Total Qty.',
  thick: 'Thickness',
  booked: 'Booked', // Added typ
  piece_no: 'Slab No.', // Added typ
  yes: 'Yes', // Added typ
  no: 'No', // Added typ
  book_match: 'Book Match', // Added typ
  surface: 'Surface', // Added typ
  pieces: 'Pieces', // Added typ
  imageLoading: 'Loading...',
  searchPlaceholderBlock: 'Search Block No.',
  imageLoadError: 'No picture',

  warehouse: 'Warehouse',
  bundle_no: 'Bundle No.',
  price_note: 'Price Note',
}
